'use client';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { SessionProvider } from 'next-auth/react';
import { mantineTheme } from '@/utils/mantine-theme';
import AppContainer from '@/components/AppContainer';
import RouterTransition from '@/components/RouterTransition';
import FloatingCartManager from '@/components/FloatingCartManager';
import DevToolsManager from '@/components/DevToolsManager';
import { AxiosInterceptorComponent } from '@/components/AxiosInterceptorComponent';
import WrapperQueryClientProvider from './WrapperQueryClientProvider';
import FloatingCollectableCoupon from '../FloatingCollectableCoupon';

export default function RootProvider({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider>
      <WrapperQueryClientProvider>
        <AxiosInterceptorComponent />
        <MantineProvider theme={mantineTheme}>
          <RouterTransition />
          <Notifications position="bottom-left" />
          <FloatingCartManager />
          <AppContainer>{children}</AppContainer>
        </MantineProvider>
        <FloatingCollectableCoupon />
        <DevToolsManager />
      </WrapperQueryClientProvider>
    </SessionProvider>
  );
}
